



































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'
import { LayoutEmailFormModel } from '@/types/interfaces/LayoutEmailFormModel'
import { TipoNotificacaoEmail } from '@/types/interfaces/TipoNotificacaoEmail'
import { HospitalGrupoRepasse } from '@/types/interfaces/HospitalGrupoRepasse'
import LayoutEmailForm from '../layout-email-form.vue'
import VariaveisPanel from '../variaveis-panel.vue'
import PreviewNotificacaoEmail from '../preview-notificacao-email.vue'

@Component({
  components: { LayoutEmailForm, VariaveisPanel, PreviewNotificacaoEmail },
})
export default class ModalAplicarLayoutGrupo extends Vue {
  @Prop() visible: boolean

  show: boolean = false
  step: number = 1
  loadingHospitais: boolean = false
  loadingSalvar: boolean = false
  carregouSemHospitais: boolean = false
  tipoList: TipoNotificacaoEmail[] = []

  nomeGrupo: string = ''
  hospitaisDoGrupo: HospitalGrupoRepasse[] = []
  hospitaisSelecionados: string[] = []
  tipo: string = ''

  formModel: LayoutEmailFormModel = {
    assunto: '',
    emailResposta: '',
    emailContato: '',
    emailCorpo: '',
    emailRodape: '',
  }

  get tipoSelecionadoDisplay(): string {
    const tipoSelecionado = this.tipoList.find(item => item.key === this.tipo)
    return tipoSelecionado ? tipoSelecionado.display : ''
  }

  get podeAvancar() {
    return !!this.tipo && this.hospitaisSelecionados.length > 0
  }

  get hospitaisConfiguraveis(): HospitalGrupoRepasse[] {
    return this.hospitaisDoGrupo.filter(hospital => hospital.podeConfigurar)
  }

  get todosSelecionados() {
    return this.hospitaisSelecionados.length === this.hospitaisConfiguraveis.length
  }

  @Watch('visible')
  async onVisibilityChange(visible: boolean) {
    this.show = visible

    if (visible) {
      this.resetarFormulario()
      await Promise.all([
        this.loadHospitaisDoGrupoLogado(),
        this.carregarTipoList(),
      ])
    }
  }

  async carregarTipoList() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipoList()

    if (response.success) {
      this.tipoList = response.data || []
    }
  }

  resetarFormulario() {
    this.step = 1
    this.tipo = ''
    this.carregouSemHospitais = false
    this.nomeGrupo = ''
    this.hospitaisDoGrupo = []
    this.hospitaisSelecionados = []
    this.formModel = {
      assunto: '',
      emailResposta: '',
      emailContato: '',
      emailCorpo: '',
      emailRodape: '',
    }

    const form = this.$refs.form as any

    if (form) {
      form.setValue(this.formModel)
    }
  }

  inserirToken(token: string) {
    const form = this.$refs.form as any

    if (form && !form.inserirToken(token)) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('Variáveis não podem ser inseridas no Assunto.', 'error'))
    }
  }

  alternarTodos() {
    this.hospitaisSelecionados = this.todosSelecionados ? [] : this.hospitaisConfiguraveis.map(hospital => hospital.id)
  }

  async loadHospitaisDoGrupoLogado() {
    this.loadingHospitais = true

    const grupoResponse = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGrupoHospital()

    if (!grupoResponse.success || !grupoResponse.data || !grupoResponse.data.id) {
      this.loadingHospitais = false
      this.carregouSemHospitais = true
      return
    }

    const hospitaisResponse = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHospitaisPorGrupo(grupoResponse.data.id)

    this.loadingHospitais = false

    if (!hospitaisResponse.success || !hospitaisResponse.data || !hospitaisResponse.data.length) {
      this.carregouSemHospitais = true
      return
    }

    this.hospitaisDoGrupo = hospitaisResponse.data
    this.hospitaisSelecionados = this.hospitaisConfiguraveis.map(hospital => hospital.id)
    this.nomeGrupo = this.hospitaisDoGrupo[0].nomeGrupo
  }

  async salvar() {
    const form = this.$refs.form as any
    const formularioValido = form.validate()

    if (!formularioValido) {
      return
    }

    this.loadingSalvar = true

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.salvarLayoutEmailLote({
      hospitaisSelecionados: this.hospitaisSelecionados,
      tipo: this.tipo,
      ...form.getValue(),
    })

    this.loadingSalvar = false

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao aplicar o layout ao grupo.', 'error'))
      return
    }

    if (response.message) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message, 'warning'))
    } else {
      EventBus.$emit('setSnackbar', getSnackbarMessage(`Layout aplicado a ${this.hospitaisSelecionados.length} hospitais.`, 'success'))
    }

    this.aplicado()
    this.close()
  }

  @Emit('aplicado')
  aplicado() { }

  @Emit('close')
  close() { }
}
